import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
import { Link } from "react-router-dom";

const Paych = () => {
    const show = false;
  if (show) {
  return (
    <React.Fragment>
      <SEO title="会议注册费| DMBD 2023" />
      <Header />
      <Breadcrumb
        image="images/bg/banner2.jpg"
        title="支付会议注册费"
        content="会议注册"
        contentTwo="支付会议注册费"
        linkage="/registration"

      />

      {/* <HomeAbout /> */}
      <EmptyTwo>
        <div classNameName="entry-header">
          <h3>会议注册费</h3>
          <br />
          <span className="pay-guide">
            (If you need English Payment Guidance, please click{" "}
            <a className="simple-link" href="pay">
              here
            </a>
            )
          </span>
        </div>
        <div classNameName="entry-content">
          <div className="fee">
            <div align="center">
              <br />
              <h5>注册费明细</h5>
            </div>
            <table className="fee">
              <tr>
                <td width="183" ><p align="center">项目 </p></td>
                <td width="152" ><p align="center">费用（人民币元） </p></td>
                <td width="691" ><p align="center">包括内容 </p></td>
              </tr>
              <tr>
                <td width="183" ><p align="center">正常注册 </p></td>
                <td width="152" ><p align="center">5940</p></td>
                <td width="691"><p>这适合于有论文录用的参会者。<br />
                  包括：Springer-LNCS论文集上发表1篇论文，电子版论文集，会议程序册，会议包，胸牌，出席所有的大会报告会、平行口头报告会和板报研讨会等。 <br />
                </p></td>
              </tr>
              <tr>
                <td ><div align="center">简化注册 </div></td>
                <td ><div align="center">3570</div></td>
                <td>
                  <p>
                    {/* 这适用于以下三种情况：<br /> */}
                    {/* 1、在线参加本次会议的论文注册。<br /> */}
                    没有论文发表的参会者或同一论文的其他作者的注册。<br />
                  </p>   </td>
              </tr>

              {/* <tr>
                <td colSpan="3" >&nbsp;</td>
              </tr> */}
            </table>
            <br />
            <span><b>注意：</b></span>
            <div align="justify"> 关于发票：<span className="entry-header">本次</span>国际会议默认都提供英文收据（Receipt）。如果你需要换开中文正规发票，
              {/* 请你在注册缴费中加上总额金额的5%的开发票税，该税款将一并开在你的发票上。 */}
              请您在完成注册缴费后，在问卷中填写发票信息。经审核无误后会在会议前为您开具相应的正规电子发票。                          </div>
            如果论文超过15页，每超1页需额外支付超页费800元
          </div>
          <p>&nbsp;</p>
          <hr />
          <p>&nbsp;</p>
          <div className="post-entry">
            {" "}
            <h3>收款方式</h3>
            <br />

            <h5>1.收款二维码：</h5>
            <br />
            <p align="center"><img src="./images/reg/yunpay.jpg" alt="2dQr" width="450" /></p>
            <p align="center">&nbsp;</p>
            <p className="STYLE39">请将会议注册费直接转账到上面云收款二维码账户中，然后将<span className="STYLE23">交易成功网页</span>保存为图片文件，并在随后填写
              Online Registration Form
              时上传。需在付款备注栏填写&quot;会议名称/论文编号&quot;（若为简化注册则填写&quot;会议名称/注册人姓名&quot;），例如&quot;DMBD2023/xxxx&quot;，
              截图成JPG图片文件并通过在线注册表上载。</p>
            <p>&nbsp;</p>
            <hr />
            <p>&nbsp;</p>
            <p>
              <h5> 2. 银行转账：</h5>
            </p>
            <span className="STYLE27">账号信息</span>
            <ul>
              <li>账户名称：北京兴汇科技有限公司</li>
              <li>开户行名称：平安银行股份有限公司北京清华园支行</li>
              <li>开户银行帐号：11014748324007</li>
            </ul>

            <p>
              <span>
                <strong>特别注明：</strong>
              </span>
              <li>
                需在备注栏填写&quot;会议名称/论文编号&quot;（若为简化注册则填写&quot;会议名称/注册人姓名&quot;），即&quot;DMBD2023/xxxx&quot;。
              </li>
              <li>
                注册中有什么疑问，请及时联系会务组。 email: dmbd2023@iasei.org<br />
              </li>
            </p>
          </div>
          <p align="center">&nbsp;</p>
          <div className="btn-nav-pay">
            {/* <a
              className="btn btn-primary btn-hover-secondary mt-s"
              href="https://wj.qq.com/s2/9997438/2b92/"
            >
              Fill Online Registration Form
            </a> */}
            <Link
              className="btn btn-primary btn-hover-secondary  mt-s"
              to={process.env.PUBLIC_URL + "/form"}
            >
              Fill Online Registration Form
              {/* Back to Registration page */}
            </Link>
            <br />
            <Link
              className="btn btn-primary btn-hover-secondary  mt-s"
              to={process.env.PUBLIC_URL + "/registration"}
            >
              Back to Registration page
            </Link>

            {/* <p>
              <a href="/Registration">Back to Registration page </a>
            </p>
            <p>
              <a href="https://iasei.org/survey/index.php/677672?lang=en">
                Fill Online Registration Form{" "}
              </a>
            </p> */}
          </div>
        </div>
      </EmptyTwo>
      {/* <AboutFive />
            <TestimonialContainer classNameOption="bg-primary-blue" />
            <CallToActionTwo /> */}
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
}
};

export default Paych;
